const MAX_DOT_RADIUS = 7;
const MIN_DOT_RADIUS = 3;

export const precipDotRadiusForZoom = (
  zoom: number,
  dotDisplayZoomLevel: number
) =>
  Math.max(
    MIN_DOT_RADIUS,
    Math.min(MAX_DOT_RADIUS, MAX_DOT_RADIUS + zoom - dotDisplayZoomLevel)
  );

export default precipDotRadiusForZoom;